import { API_URL } from 'shared/api/Constants';
import { apiInterceptor } from './axios';

export const getAllRolesAPI = () => {
  return apiInterceptor.get(`${API_URL.GET_ALL_ROLES}`).then((response: any) => {
    return response;
  });
};

export const createRoleAPI = (data: any) => {
  return apiInterceptor.post(`${API_URL.CREATE_ROLE}`, data).then((response: any) => {
    return response;
  });
};

export const updateRoleAPI = (roleId: string, data: any) => {
  return apiInterceptor.put(`${API_URL.UPDATE_ROLE}/${roleId}`, data).then((response: any) => {
    return response;
  });
};

export const deactivateRoleAPI = (id: any) => {
  return apiInterceptor.delete(`${API_URL.DEACTIVATE_ROLE}/${id}`).then((response: any) => {
    return response;
  });

};

export const getRoleByIdAPI = (id: any) => {
  return apiInterceptor.get(`${API_URL.GET_ALL_ROLES}/${id}`).then((response: any) => {
    return response;
  });

};

export const getRolePermissionsAPI = (id: any) => {
  return apiInterceptor.get(`${API_URL.GET_ROLE_PERMISSIONS}/${id}/permissions`).then((response: any) => {
    return response;
  });
};

export const getActivePermissionsAPI = () => {
  return apiInterceptor.get(`${API_URL.GET_ACTIVE_PERMISSIONS}`).then((response: any) => {
    return response;
  });
};

export const updateRolePermissionsAPI = (id: any, data: any) => {
  return apiInterceptor.put(`${API_URL.UPDATE_PERMISSION}/${id}`, data).then((response: any) => {
    return response;
    });
};

